<script>
    export let organizations, options, showMultiSelect = false, codes, params;
    let selectedOrgs = options.chartOrgs? options.chartOrgs.split(","): [];
    let dropdownOpenedFirstTime = false; //Used to set inputs checked
    import {onMount} from 'svelte';
    //In case there are only one selected org
    let selectedOrg = {
        id : "",
        name: ""
    };
    let totalOrgSelected = selectedOrgs.length;
    if(totalOrgSelected == 1){
        selectedOrg.id = selectedOrgs;
        selectedOrg.name = getOrg(selectedOrg.id);
    }
    $: paramsChanged(params);
    $: totalOrgSelected;
    function paramsChanged(params){
        let organizationsToRemove = [];
        selectedOrgs = (params && params.org) ? params.org.split(",") : [];
        selectedOrgs.map(org => {
            if(codes[org] && !codes[org].includes(params.subMenu)){
                jQuery("#cbx-"+org).click();
                organizationsToRemove.push(org);
            }
        });
        selectedOrgs = selectedOrgs.filter(kpi => !organizationsToRemove.includes(kpi));
        getOrgUrl();
        jQuery('#btnDone').click();
    }
    function openDropdown(){
        showMultiSelect = !showMultiSelect
        //Set selected orgs at the first time
        if(!dropdownOpenedFirstTime){
            totalOrgSelected = 0;
            jQuery('.cbx-org').each(function() {
                if(selectedOrgs.includes(this.id.split("-")[1])){
                    jQuery(this).prop("checked", true);
                    totalOrgSelected++;
                }
            });
            dropdownOpenedFirstTime = true;
        }
    }
    function orgClicked (org){
        totalOrgSelected = 0;
        jQuery('.cbx-org').each(function() {
            if(jQuery(this).prop("checked")){
                totalOrgSelected++;
                selectedOrg.id = this.id.split("-")[1];
            }
        });

        if(totalOrgSelected == 1){
            selectedOrg.name = getOrg(selectedOrg.id);
        }
    }

    function order ( a, b ){ return a - b; }

    function getOrgUrl(){
        let organizationsWithCommas = [];

        jQuery('.cbx-org').each(function() {
            if(jQuery(this).prop("checked")){
                organizationsWithCommas.push(this.id.split("-")[1]);
            }
        });

        if(organizationsWithCommas.length == 0){
            //Avoid to keep it empty
            options.chartOrgs = '0'
        }else{
            options.chartOrgs = organizationsWithCommas.sort(order).join(',');
        }

        showMultiSelect = false
    }

    onMount(async () => {
        if(options.menu.url == "charts"){
            selectedOrgs.map(id => {
                jQuery('#cbx-' + id).prop("checked",true);
            })
        }
    });

    //Get org name by id
    function getOrg(orgId) {
        var org = organizations.filter((o) => o.id == orgId);
        return (org.length == 1) ? org[0].name : "Select organizations";
    }
</script>

<div class=" {(options.menu.url != 'charts') ? 'offset-2 ' : ''} col-md-3 mt-3">
    <div class="dropdown" id="org-selector" >
        {#if selectedOrgs && organizations && organizations.length > 1}
            {#if options.menu.url == 'charts'}
                 <button class="btn dropdown-toggle" on:click={ () => openDropdown()} type="button" id="dropdownOrganizations"  aria-haspopup="true" aria-expanded="false">
                    {#if totalOrgSelected == 0}
                        Select organizations
                    {:else if  totalOrgSelected == 1}
                        {selectedOrg.name}
                    {:else}
                        {totalOrgSelected} Selected
                    {/if}
                </button>

                <div class="dropdown-menu { (showMultiSelect) ? 'show' : '' }" aria-labelledby="dropdownOrganizations" id="organization-multiselect">
                    <div class="options">
                        {#each organizations as organization}
                            <div class="dropdown-item multiselect-item pointer { (codes && codes[organization.id] && codes[organization.id].includes(params.subMenu) ? '' : 'disabled')}">
                                <label for="cbx-{organization.id}" class="btn-block" on:click={ () => orgClicked(organization) }>
                                    <input type="checkbox" id="cbx-{organization.id}" class="cbx-org" checked="{selectedOrgs.indexOf(organization.id) > 0 && (codes && codes[organization.id] && codes[organization.id].includes(params.subMenu))}">
                                    {organization.name}
                                </label>
                            </div>
                        {/each}
                    </div>
                    <a class="btn btn-primary text-light btn-block  text-center" id="btnDone"
                        on:click={() => getOrgUrl()}
                        href="/{options.menu.url}/{options.chartOrgs}{(options.subMenu)?'/'+options.subMenu:''}/{options.year}/{options.month}">
                        Update</a>
                </div>
            {:else}
                <!-- Select only one organization -->
                <button class="btn dropdown-toggle" type="button" id="dropdownOrganizations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {options.org.name}
                </button>

                <div class="dropdown-menu" aria-labelledby="dropdownOrganizations">
                    {#each organizations as organization}
                        <a on:click={ () => options.org = organization }
                        href="/{options.menu.url}/{organization.id}{(options.subMenu)?'/'+options.subMenu:''}/{options.year}/{options.month}"
                        class="dropdown-item">
                        {organization.name}
                        </a>
                    {/each}
                </div>
            {/if}
        {:else}
            <div id="dropdownOrganizations" class="btn">{options && options.org? options.org.name: 'Unauthorized'}</div>
        {/if}
    </div>
</div>
